import Immutable from "immutable";
import { sha224 } from "services/hash";
import RecordClassCreator from "services/record";

interface ResponseFilterItemAttributes {
  content?: Immutable.List<Immutable.Map<string, unknown>>;
  description?: string;
  handle?: string;
  responseId: string;
  blocks?: Immutable.Map<string, Immutable.List<unknown>>;
}

export default class ResponseFilterItem extends RecordClassCreator<ResponseFilterItemAttributes>({
  type: "responseFilterItem",
  content: null,
  description: null,
  handle: null,
  responseId: null,
  blocks: null
}) {
  static getFetchManyUrl(): string {
    return "/responses/filter";
  }

  static getFetchManyUrlParams(params: {filter: {query: string}}): Record<string, unknown> {
    return { userinput: params.filter.query };
  }

  static resolveFetchManyResult(
    payload: {responses: Record<string, unknown>[]}
  ): Record<string, unknown> {
    return {
      ...payload,
      data: payload.responses.map((item: Record<string, unknown>) => ({
        ...item,
        _id: sha224(item), // Hash item body and use it as ID to make sure it is unique
        responseId: item._id
      }))
    };
  }
}
